module.exports = __webpack_public_path__ + "img/tmn.01a6a8a0.png";